import i18n from '@/plugins/vue-i18n'

export default {
  params: ['length'],
  message: () => i18n.t('validation.string-length'),
  validate (value, { length }) {
    return value.length <= length
  }
}
